import { gql } from '@apollo/client';
import OpportunitySelection from 'services/graphQL/fragments/opportunity';

export default class OpportunitySubscription {
    static OPPORTUNITY_LIST_UPDATED = gql`
        subscription opportunityListUpdated($filters: CRMFilterInput, $lots: [Int]!) {
            opportunityListUpdated(filters: $filters, lots: $lots) {
                type
                opportunity {
                    crmId
                    leadCode
                    leadSource
                    leadSourceId
                    leadType
                    stockNumber
                    vehicleYear
                    vehicleMake
                    vehicleModel
                    vehicleTrim
                    closedDate
                    lastAction
                    notes
                    prospect {
                        customerCode
                        firstName
                        lastName
                        cellPhone
                        email
                    }
                    coProspect {
                        customerCode
                        firstName
                        lastName
                    }
                    vehicle {
                        customStockNumber
                        style
                        thumbnail
                    }
                    processStage
                    lastResults
                    noDeal
                    lotName
                    recordManager
                    appointmentSalesman
                    recordManagerId
                    salespersonId
                    modifiedOn
                    createdOn
                    status
                    tags {
                        name
                        tagId
                        color
                    }
                    automatedResponseType
                    sold
                    showed
                    showedDate
                    prospectLeftDate
                    demo
                    writeUp
                    finance
                }
            }
        }
    `;

    static OPPORTUNITY_UPDATED = gql`
        subscription opportunityUpdated($crmId: ID!) {
            opportunityUpdated(crmId: $crmId) {
                ${OpportunitySelection}
            }
        }
    `;

    static PROSPECT_OR_CO_PROSPECT_CHANGED = gql`
        subscription prospectOrCoProspectChanged($crmId: ID!) {
            prospectOrCoProspectChanged(crmId: $crmId) {
                type
                prospect {
                    customerCode
                    customerId
                    firstName
                    middleName
                    lastName
                    email
                    cellPhone
                    homePhone
                    workPhone
                    dob
                    ssn
                    dln
                    isBusiness
                    allowCallCellPhone
                    allowTextCellPhone
                    allowCallHomePhone
                    allowCallWorkPhone
                    inHouseServiceCustomer
                    currentAddress {
                        customerAddressId
                        address1
                        address2
                        state
                        city
                        county
                        country
                        zipCode
                        phone
                        housingStatus
                        mortgageOrRent
                        totalMonths
                        start
                        end
                    }
                    currentEmployment {
                        customerEmploymentId
                        employer
                        title
                        totalMonths
                        monthlyIncome
                        workPhone
                        otherIncomeMonthly
                        otherIncomeSource
                        address1
                        address2
                        city
                        state
                        zipCode
                        county
                        country
                        status
                    }
                }
            }
        }
    `;
}
